import { Component, Input } from '@angular/core';

/**
 * Standard page header: a breadcrumb trail over an h1 title. Use at the top of a
 * page so every page presents an identical header and they cannot drift apart.
 *
 * Usage: `<bk-page-header [breadcrumbs]="[getCompany(), getBureau(), 'Events']" title="Events">`
 * The breadcrumbs array is passed straight to app-breadcrumb (strings, or the
 * Company/Bureau objects from BaseComponent which carry their own titles/links).
 */
@Component({
  selector: 'bk-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  @Input() breadcrumbs: any[] = [];
  @Input() title = '';
}
